import { Model } from '@/app/shared/models/model';
import { TrackingsType } from './TrackingsType.model';
import { TypeIdEnum } from '../../enums';

export class CommunicationResponseModel extends Model {
  public CampaignId!: string;
  public CommunicationId!: string;
  public ContractId!: string;
  public Recipient!: string;
  public Tracking!: string;
  public TypeId!: TypeIdEnum;
  public Scheduled!: Date;
  public TrackingDate!: Date;
  public Content!: string;
  public MessageId!: string;
  public Trackings: TrackingsType[] = [];
  public Subject!: string;
  public Provider!: string;
  public MerchantKey!: string;
  public RecipientId!: string;
  public ReturnDescription!: string;
  public LinkExpired!: boolean;
  public LinkValidity!: Date;
  public LinkExpirationDays!: number;
}
